import { CaptureContext } from '../services/posthogService'
import { getRouteTemplate } from './routeTemplate'

export const getPageContext = (): CaptureContext['page'] => {
  if (typeof window === 'undefined') return undefined
  return {
    // Route template, never the concrete path/ids.
    path: getRouteTemplate(window.location.pathname),
    title: document.title,
    // The referrer can itself be a concrete URL from this app; template it
    // too rather than forwarding it verbatim.
    referrer: document.referrer ? getRouteTemplate(new URL(document.referrer, window.location.origin).pathname) : '',
  }
}

export const getDeviceContext = (): CaptureContext['device'] => {
  if (typeof window === 'undefined') return undefined
  return {
    screen_width: window.screen.width,
    screen_height: window.screen.height,
  }
}

export const getSessionContext = (startTime: number, lastEventTime: number): CaptureContext['session'] => {
  const now = Date.now()
  return {
    duration_ms: now - startTime,
    time_since_last_event_ms: now - lastEventTime,
  }
}

export const getFeatureContext = (featureName?: string, featureCategory?: string): CaptureContext['feature'] => {
  if (!featureName) return undefined
  return {
    name: featureName,
    category: featureCategory,
  }
}

export const enrichEventProperties = (
  baseProperties: Record<string, unknown> = {},
  context: CaptureContext = {}
): Record<string, unknown> => {
  const { page, feature, session, device } = context
  
  return {
    ...baseProperties,
    // Page context
    $current_url: page?.path,
    $pathname: page?.path,
    page_title: page?.title,
    referrer: page?.referrer,

    // Feature context
    feature_name: feature?.name,
    feature_category: feature?.category,

    // Session context
    session_duration_ms: session?.duration_ms,
    time_since_last_event_ms: session?.time_since_last_event_ms,

    // Device context
    screen_width: device?.screen_width,
    screen_height: device?.screen_height,
  }
}

export const hashString = async (value: string): Promise<string> => {
  const data = new TextEncoder().encode(value)
  const digest = await crypto.subtle.digest('SHA-256', data)
  const bytes = Array.from(new Uint8Array(digest))
  return bytes.map(b => b.toString(16).padStart(2, '0')).join('')
}
